import { Flex } from 'antd';
import React, { FC } from 'react';

import ImgTeamEmpty from '@/shared/pictures/team_empty.png';
import { useNavigate } from 'react-router';

interface MyTeamEmptyProps{
  searchClick: () => void;
}

export const MyTeamEmpty:FC<MyTeamEmptyProps> = ({searchClick}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className='myTeam-empty'>
        <img className='myTeam-empty_img' src={ImgTeamEmpty} alt="empty-img" />
        <h2 className='myTeam-empty_title'>Вы пока не состоите <br/>ни в одной команде.</h2>
        <p className='myTeam-empty_text'>Но кажется самое время начать! <br/>
        <span>Вас ждет:</span> Ускоренная регенерация энергии <br/> у лидера и участников клана!</p>
      </div>
      <Flex vertical gap={16} style={{width:'100%'}}>
          <div className='myTeam-empty_button' onClick={()=>searchClick()}>Найти команду</div>
          <div className='myTeam-empty_button blue' onClick={()=>navigate('/team-create')}>Создать свою команду</div>
      </Flex>
    </>
  );

};
